import Basic from '@rebuild/materials/shared/home_wrapper/BaseWrapper.vue';
import MobBasic from './mob-basic.vue';
import { withProvider } from '@rebuild/hooks/useCompWithProvider';
import { provideCurrentContext } from '@rebuild/materials/shared/home_wrapper/context';

function useSelfContext() {
	provideCurrentContext();
}

export const componentMap = {
	basic: withProvider(Basic, useSelfContext),
	'mob-basic': withProvider(MobBasic, useSelfContext)
};

